/* eslint-disable no-constant-condition */
import React, { useState, useEffect } from "react";
// ANT DESIGN COMPONENTS
import { Select } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// CUSTOM HOOKS
import useGetAllMessages from "../../../customHooks/GET_requests/useGetAllMessages";
// COMPONENTS
import GlobalAlert2 from "../../home/GlobalAlert2";
// INTERFACES
import { MessageInterface } from "../../../interfaces/Message.interface";

export default function SelectMessagesMultiple({
	inputValue,
	inputOnChange,
	disabledInput,
	displaySelect,
	messageType = "",
}: {
	inputValue: string[];
	inputOnChange: (ids: string[]) => void;
	disabledInput: boolean;
	displaySelect: boolean;
	messageType?: string;
}) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const { Option } = Select;
	const [t] = useTranslation("global");

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */
	const [data, setData] = useState<MessageInterface[]>([]);

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// CUSTOM HOOKS *********************************** */
	const { messages, isLoadingGetAllMessages, errorMessageGetAllMessages, isErrorGetAllMessages } = useGetAllMessages();

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const onChange = (newValues: string[]) => {
		inputOnChange(newValues || []);
	};

	// ************************************************ */
	// USE EFFECT ************************************* */
	useEffect(() => {
		if (messages) {
			let filteredMessages = messages;

			if (messageType) {
				const normalizedType = messageType.toUpperCase();
				filteredMessages = messages.filter(
					(msg: MessageInterface) =>
						msg.message_type?.name?.toUpperCase() === normalizedType
				);
			}

			setData([...filteredMessages]);
		}
	}, [messages, messageType]);

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div className=' generalStyles__width100'>
			{displaySelect ? (
				<Select
					mode='multiple'
					loading={isLoadingGetAllMessages}
					size='middle'
					className='generalStyles__width100'
					value={inputValue}
					placeholder={t("general.message")}
					onChange={onChange}
					showSearch
					optionFilterProp='label'
					filterOption={(input, option) =>
						typeof option?.label === "string" && option.label.toLowerCase().includes(input.toLowerCase())
					}
					allowClear
					disabled={disabledInput}
					maxTagCount='responsive'
					style={{ width: "300px" }}
				>
					{data.map((item: MessageInterface) => (
						<Option key={item.id} value={item.id} label={item.short_message}>
							<span className='generalStyles__info'>
								{item && item.message_type && item.message_type.name ? item.message_type.name : ""}
							</span>
							: {item.short_message}
						</Option>
					))}
				</Select>
			) : (
				(() => {
					const selectedMessages = data.filter((p: MessageInterface) => inputValue && inputValue.includes(p.id));
					return (
						<span className='generalStyles__width100'>
							{selectedMessages.length > 0 ? (
								selectedMessages.map((msg, index) => (
									<span key={msg.id}>
										<span className='generalStyles__info'>{msg?.message_type?.name || ""}</span>:{" "}
										{msg.short_message || "--"}
										{index < selectedMessages.length - 1 ? ", " : ""}
									</span>
								))
							) : (
								"--"
							)}
						</span>
					);
				})()
			)}
			<GlobalAlert2
				isError={isErrorGetAllMessages}
				isSuccess={false}
				requestType='GET'
				error={errorMessageGetAllMessages}
				name='Messages'
			/>
		</div>
	);
}
